import React from "react"

import useDebouncedResize from "../../hooks"
import { League } from "../types"
import ListView from "./ListView"
import TableView from "./TableView"

interface PastLeaguesProps {
  leagues: Array<League>
}

export default function PastLeagues({ leagues }: PastLeaguesProps) {
  const { width } = useDebouncedResize()
  const listView = React.useMemo(() => width < 600, [width])

  if (listView) {
    return <ListView leagues={leagues} />
  }

  return <TableView leagues={leagues} />
}
